(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@apg-stats/apg-core", [], factory);
	else if(typeof exports === 'object')
		exports["@apg-stats/apg-core"] = factory();
	else
		root["@apg-stats/apg-core"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 